(function(){try{
  /* Case 31 - keeps per-stocking gift add-ons consistent with their stockings, on every page.
     Loaded site-wide from layout/theme.liquid because the cart can change anywhere: the cart page,
     SlideCart, GiftLab, a quantity box. Contract written by assets/saga-stocking-gift.js: a stocking
     line and its add-on lines share one hidden _saga_gift_id; add-on lines carry _saga_addon.

     Rules, applied after any cart change and once on load when the cart holds gift lines:
       - a wrap/card line always has the SAME quantity as its stocking line (one paid unit per stocking);
       - stocking removed -> its wrap/card lines are removed;
       - wrap or card line removed while the stocking still says it is wrapped / has a card -> the
         stocking is re-added without that property (Shopify cannot edit properties in place), so the
         order never promises wrapping or a card that was not paid for;
       - GiftLab's order-level "wrap my order" line (the same `wrap` variant, without _saga_addon) is
         removed and its cart offer hidden while any stocking is wrapped per stocking, so wrapping is
         never charged twice.
     2026-09-15 order gift (snippets/saga-order-gift.liquid): lines with _saga_gift_id "order" belong to the
     whole order, not to one item. They are kept at quantity 1 and one of each (wrap, card); removed when the
     cart has no regular item left (regular = not a stocking or gift box, not an add-on, not a gift card);
     the wrap line's "Wrap items" is kept equal to the regular items, rewritten in place with /cart/change.js
     (the line keeps its position). A wrapped order also removes a GiftLab wrap line.
     Our own requests carry X-Saga-Sync so they do not trigger another pass. No customer-visible text. */
  var C=window.SagaGiftSync;
  if(!C||!window.fetch||!window.Promise)return;
  var RX=/[/]cart[/](add|change|update|clear)(\.js)?([?#]|$)/,HDR='X-Saga-Sync',ORDER='order';
  var nativeFetch=window.fetch,busy=false,again=false,timer=null;
  function root(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function req(path,body){
    var h={'Accept':'application/json','Content-Type':'application/json'};h[HDR]='1';
    return nativeFetch.call(window,root()+path,{method:body?'POST':'GET',credentials:'same-origin',headers:h,body:body?JSON.stringify(body):undefined})
      .then(function(r){if(!r.ok)throw new Error('http '+r.status);return r.json();});
  }
  /* Case 38 - header cart badge. sections/header.liquid renders <span class="cart-link__count"> inside
     .cart-link__icon only when the cart is not empty, and nothing in theme.js ever updates it (the theme's
     own AJAX add only fires theme:cartchanged). Any cart change without a page load left it stale. This
     keeps that one existing element in step with /cart.js item_count (sum of line quantities, so paid
     wrapping and card lines count too). It never adds a second counter. */
  function paintCount(n){
    n=Math.max(0,parseInt(n,10)||0);
    document.querySelectorAll('.cart-link .cart-link__icon').forEach(function(icon){
      var el=icon.querySelector('.cart-link__count');
      if(n>0){
        if(!el){el=document.createElement('span');el.className='cart-link__count';icon.appendChild(el);}
        if(el.textContent!==String(n))el.textContent=String(n);
      }else if(el){el.parentNode.removeChild(el);}
    });
  }
  window.SagaCartCount=function(n){
    if(typeof n==='number'){paintCount(n);return Promise.resolve(n);}
    return req('cart.js').then(function(c){paintCount(c.item_count);return c.item_count;},function(){});
  };
  function flagged(init){
    try{var h=init&&init.headers;if(!h)return false;if(typeof h.get==='function')return !!h.get(HDR);return !!(h[HDR]||h[HDR.toLowerCase()]);}catch(e){return false;}
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(run,300);}
  window.fetch=function(input,init){
    var p=nativeFetch.apply(this,arguments);
    try{
      var url=typeof input==='string'?input:(input&&input.url)||'';
      if(RX.test(url)&&!flagged(init))p.then(schedule,function(){});
    }catch(e){}
    return p;
  };
  if(window.XMLHttpRequest){
    var xo=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(m,url){
      try{if(RX.test(String(url)))this.addEventListener('load',schedule);}catch(e){}
      return xo.apply(this,arguments);
    };
  }

  /* a stocking has a card when it names one: Case 35 keeps it in Card name; Case 31 carts kept the
     name in Greeting card itself, which is now only Yes/No */
  function hasCard(p){return !!(p['Card name']||(p['Greeting card']&&!/^(Yes|No)$/.test(p['Greeting card'])));}
  /* Case 56 - Gift Box name embroidery (assets/saga-giftbox.js): the box line lists its named items in
     _saga_names ("Blue bib name|Cream bib name"); each named item has one name line (_saga_addon=name,
     _saga_item = that key). Same rules as wrap/card, per item: a name line follows the box quantity; box
     removed -> its name lines are removed; a name line removed -> the box is re-added without that name, so
     the order never promises embroidery that was not paid for. Stocking carts have no name lines: unchanged. */
  function namesOf(p){return String(p._saga_names||'').split('|').filter(function(k){return !!k&&!!p[k];});}
  /* Migration 2026-09-16: to wrap-varianter (klassisk + jul). Begge tæller som wrap-tilvalget, og en gammel
     linje flyttes KUN til den anden variant, når linjens egen 'Wrapping style' siger det - aldrig på gæt. */
  /* 2026-09-29 - a group gift's label (Gift on the stockings, For on its wrap and card lines) is written
     once at add-to-cart from the embroidered names, e.g. "Carla, Jeppe, Otto". If the customer then removes
     one stocking, the Shipmondo pick list would still name a stocking that is no longer in the order, so the
     label is rewritten from the stockings that are actually left. The original order is kept by filtering the
     stored label instead of rebuilding it from the cart, which lists lines newest first; repeated names are
     matched one for one, and a trailing " (2)" from a same-label collision elsewhere in the cart is preserved.
     An un-personalised group carries the canonical "Gift (n stockings)" instead, so n is recounted.
     null means leave it alone: nothing was removed, or the label is not one we wrote. */
  function relabel(label,stock){
    var s=String(label||''),suf='',i,tot=0;
    var mu=s.match(/^(.*?)( \(\d+\))$/);
    if(mu){s=mu[1];suf=mu[2];}
    stock.forEach(function(it){tot+=it.quantity;});
    if(!tot)return null;
    var mg=s.match(/^Gift \((\d+) stockings\)$/);
    if(mg)return Number(mg[1])===tot?null:'Gift ('+tot+' stockings)'+suf;
    var have={};
    stock.forEach(function(it){var nm=(it.properties||{})['Name Stocking'];if(nm)have[nm]=(have[nm]||0)+it.quantity;});
    var parts=s.split(', '),out=[];
    for(i=0;i<parts.length;i++){if(have[parts[i]]>0){have[parts[i]]--;out.push(parts[i]);}}
    if(!out.length||out.length===parts.length)return null;
    return out.join(', ')+suf;
  }
  function isWrapVariant(id){return id===C.wrap||(C.wrapChristmas&&id===C.wrapChristmas);}
  function wantWrapVariant(style){var s=String(style||'');if(s==='Christmas Wrapping')return C.wrapChristmas||C.wrap;if(s)return C.wrap;return null;}
  /* order gift: which lines the order wrapping covers (same rule as snippets/saga-order-gift-special.liquid) */
  function isSpecial(it){return String(it.handle||'').indexOf('christmas-stocking')>-1||(C.special||[]).indexOf(it.product_id)>-1;}
  function isRegular(it){
    var p=it.properties||{};
    if(p._saga_addon||p._gpo_parent_product_group||p._saga_gift_id===ORDER)return false;
    if(it.gift_card||it.requires_shipping===false)return false;
    if(isWrapVariant(it.variant_id)||it.variant_id===C.card)return false;
    return !isSpecial(it);
  }
  /* "Wrap items": readable for the packer - title (variant) [SKU] x quantity, one entry per regular line */
  function wrapItems(cart){
    return (cart.items||[]).filter(isRegular).map(function(it){
      var v=it.variant_title&&it.variant_title!=='Default Title'?' ('+it.variant_title+')':'';
      return String(it.product_title||it.title||'')+v+(it.sku?' [SKU '+it.sku+']':'')+' × '+it.quantity;
    }).join('; ');
  }
  C.wrapItems=wrapItems;
  function plan(cart){
    var groups={},updates={},readd=[],fix=[],count=0,wrapped=false,loose=[],order={wrap:[],card:[]};
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{},gid=p._saga_gift_id;
      if(!gid){if(isWrapVariant(it.variant_id))loose.push(it);return;}
      if(gid===ORDER){if(p._saga_addon==='wrap')order.wrap.push(it);else if(p._saga_addon==='card')order.card.push(it);return;}
      var g=groups[gid]||(groups[gid]={s:[],wrap:[],card:[],name:[]});
      if(p._saga_addon==='wrap')g.wrap.push(it);else if(p._saga_addon==='card')g.card.push(it);else if(p._saga_addon==='name')g.name.push(it);else g.s.push(it);
    });
    function set(key,q){updates[key]=q;count++;}
    function follow(list,q){list.forEach(function(it,i){var want=i===0?q:0;if(it.quantity!==want)set(it.key,want);});}
    function sum(list){return list.reduce(function(a,it){return a+it.quantity;},0);}
    Object.keys(groups).forEach(function(gid){
      var g=groups[gid],S=sum(g.s);
      var wantWrap=g.s.some(function(it){return !!it.properties['Wrapping style'];});
      var wantCard=g.s.some(function(it){return hasCard(it.properties);});
      var wantNames={},byItem={},dropNames=[];
      g.s.forEach(function(it){namesOf(it.properties).forEach(function(k){wantNames[k]=true;});});
      g.name.forEach(function(it){var k=it.properties._saga_item||'';(byItem[k]=byItem[k]||[]).push(it);});
      if(S===0){follow(g.wrap,0);follow(g.card,0);follow(g.name,0);return;}
      /* 2026-09-29 group gift ("Pak alle samlet som en gave", assets/saga-stocking-gift.js): the whole
         group is ONE gift, so it keeps one wrap line and one card line however many stockings it holds.
         Every other group is unchanged: one paid unit per stocking. Name embroidery always follows S. */
      var isGroup=g.s.some(function(it){return (it.properties||{})._saga_gift_mode==='group';});
      var addonQty=isGroup?1:S;
      var newLab=null;
      if(isGroup){
        var cur=null;
        g.s.forEach(function(it){if(cur===null&&it.properties['Gift'])cur=it.properties['Gift'];});
        g.wrap.concat(g.card).forEach(function(it){if(cur===null&&it.properties['For'])cur=it.properties['For'];});
        if(cur!==null)newLab=relabel(cur,g.s);
      }
      var dropWrap=wantWrap&&sum(g.wrap)===0,dropCard=wantCard&&sum(g.card)===0;
      if(wantWrap&&!dropWrap)follow(g.wrap,addonQty);else follow(g.wrap,0);
      if(wantCard&&!dropCard)follow(g.card,addonQty);else follow(g.card,0);
      Object.keys(byItem).forEach(function(k){follow(byItem[k],wantNames[k]?S:0);});
      Object.keys(wantNames).forEach(function(k){if(!byItem[k]||sum(byItem[k])===0)dropNames.push(k);});
      if(wantWrap&&!dropWrap)wrapped=true;
      if(dropWrap||dropCard||dropNames.length){
        g.s.forEach(function(it){
          var np={};Object.keys(it.properties).forEach(function(k){np[k]=it.properties[k];});
          if(dropWrap){delete np['Wrapping style'];if('Gift wrapping' in np)np['Gift wrapping']='No';}
          if(dropCard){['Card name','Card no.','Card message','To','From','Greeting'].forEach(function(k){delete np[k];});if('Greeting card' in np)np['Greeting card']='No';}
          if(dropNames.length){
            dropNames.forEach(function(k){delete np[k];});
            var left=String(np._saga_names||'').split('|').filter(function(k){return !!k&&dropNames.indexOf(k)<0;});
            if(left.length)np._saga_names=left.join('|');else delete np._saga_names;
          }
          if(newLab&&np.Gift)np.Gift=newLab;
          if(!np['Wrapping style']&&!hasCard(np)&&!namesOf(np).length){delete np._saga_gift_id;delete np.Gift;delete np['Gift group'];delete np._saga_gift_mode;}
          set(it.key,0);
          readd.push({id:it.variant_id,quantity:it.quantity,properties:np});
        });
      }
      /* every line that survives keeps its key, its price and its quantity: only the one label property is
         rewritten in place with /cart/change.js, so no add-on is ever duplicated and the card text, the shared
         _saga_gift_id and the wrapping all stay exactly as they were. Lines already scheduled for removal or
         for a rebuild above are skipped - they carry the new label on their way back in. */
      if(newLab){
        g.s.concat(g.wrap,g.card).forEach(function(it){
          if(updates[it.key]===0)return;
          var p=it.properties||{},k=p._saga_addon?'For':'Gift';
          if(!p[k]||p[k]===newLab)return;
          var np={};Object.keys(p).forEach(function(x){np[x]=p[x];});
          np[k]=newLab;
          fix.push({id:it.key,quantity:updates[it.key]===undefined?it.quantity:updates[it.key],properties:np});count++;
        });
      }
    });
    if(order.wrap.length||order.card.length){
      if(!(cart.items||[]).some(isRegular)){follow(order.wrap,0);follow(order.card,0);}
      else{
        follow(order.wrap,1);follow(order.card,1);
        if(order.wrap.length){
          wrapped=true;
          var w=order.wrap[0],want=wrapItems(cart);
          if(String(w.properties['Wrap items']||'')!==want){
            var wp={};Object.keys(w.properties).forEach(function(k){wp[k]=w.properties[k];});
            wp['Wrap items']=want;
            fix.push({id:w.key,quantity:1,properties:wp});count++;
          }
        }
      }
    }
    /* gamle kurve: flyt en wrap-linje til den variant, dens egen 'Wrapping style' navngiver */
    var allWrap=order.wrap.slice();
    Object.keys(groups).forEach(function(gid){allWrap=allWrap.concat(groups[gid].wrap);});
    allWrap.forEach(function(it){
      if(updates[it.key]===0)return;
      var want=wantWrapVariant((it.properties||{})['Wrapping style']);
      if(!want||it.variant_id===want)return;
      /* linjen forsvinder, så en allerede planlagt property-rettelse på dens nøgle ville ramme en slettet linje:
         tag rettelsens properties med over på den nye linje i stedet, og fjern den forældede fix. */
      var np={};Object.keys(it.properties||{}).forEach(function(k){np[k]=it.properties[k];});
      for(var i=fix.length-1;i>=0;i--){if(fix[i].id===it.key){if(fix[i].properties)np=fix[i].properties;fix.splice(i,1);count--;}}
      set(it.key,0);
      readd.push({id:want,quantity:it.quantity,properties:np});
    });
    if(wrapped)loose.forEach(function(it){set(it.key,0);});
    return {updates:updates,count:count,readd:readd,fix:fix,wrapped:wrapped};
  }
  function mark(on){try{document.documentElement.classList.toggle('saga-gift-wrapped',!!on);}catch(e){}}
  function onCartPage(){return !!document.querySelector('[data-section-type="cart-template"]');}
  window.SagaCartRefresh=function(open){
    try{if(typeof window.SLIDECART_UPDATE==='function')window.SLIDECART_UPDATE();}catch(e){}
    if(!open)return true;
    try{if(typeof window.SLIDECART_OPEN==='function'){window.SLIDECART_OPEN();return true;}}catch(e){}
    return false;
  };
  function run(){
    if(busy){again=true;return;}
    busy=true;
    req('cart.js').then(function(cart){
      var pl=plan(cart);
      mark(pl.wrapped);
      paintCount(cart.item_count);
      if(!pl.count)return false;
      /* removals and quantity fixes first, then re-add stripped stockings, then in-place property fixes */
      return (Object.keys(pl.updates).length?req('cart/update.js',{updates:pl.updates}):Promise.resolve(null))
        .then(function(){return pl.readd.length?req('cart/add.js',{items:pl.readd}):null;})
        .then(function(){return pl.fix.reduce(function(p,f){return p.then(function(){return req('cart/change.js',f);});},Promise.resolve(null));})
        .then(function(){return req('cart.js');})
        .then(function(after){paintCount(after.item_count);mark(plan(after).wrapped);return true;});
    }).then(function(changed){
      busy=false;
      if(changed){
        if(onCartPage()){window.location.reload();return;}
        window.SagaCartRefresh(false);
      }
      if(again){again=false;schedule();}
    },function(){busy=false;});
  }
  /* always on load (badge from /cart.js; add-on fixes only when needed), after back/forward cache
     restores, and after the theme's own cart events */
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  window.addEventListener('pageshow',function(e){if(e.persisted)schedule();});
  document.documentElement.addEventListener('theme:cartchanged',schedule);
}catch(e){}})();
